module.exports = __webpack_public_path__ + "static/media/JAP225.cb395dde.svg";